import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import { PermissionProvider } from "Context/PermissionContext";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <PermissionProvider>
      <App />
    </PermissionProvider>
  </BrowserRouter>
);
